export const PAYWALL_SHOW = 'paywall:show'
export const PAYWALL_HIDE = 'paywall:hide'
export const PAYWALL_UPGRADE = 'paywall:upgrade'
export const SHOW_UPGRADE_PLAN_MODAL = 'show-upgrade-plan-modal'
export const SHOW_UPGRADE_PLAN_MODAL_V2 = 'show-upgrade-plan-modalV2'
export const SHOW_UBB_UPGRADE_PLAN_MODAL = 'show-ubb-upgrade-plan-modal'
export const UBB_UPGRADE_SUCCESS = 'ubb:upgrade-success'
export const SHOW_TRIAL_MODAL = 'show-trial-modal'
export const SHOW_PAYMENT_INFORMATION_MODAL = 'show-payment-information-modal'
export const UPGRADE_PLAN_SHOW_PAYMENT_MODAL = 'upgrade-plan:show-payment-modal'
export const UPGRADE_PLAN_PAYMENT_MODAL_CLOSED = 'upgrade-plan:payment-modal-closed'
export const BILLING_OPEN_CC_MODAL = 'billing:open-cc-modal'
export const BILLING_OPEN_PAYPAL_MODAL = 'billing:open-paypal-modal'
export const BILLING_OPEN_ADD_CARD_MODAL = 'billing:open-add-card-modal'
export const BILLING_OPEN_MANAGE_PLAN_MODAL = 'billing:open-manage-plan-modal'
export const BILLING_CARD_ADDED = 'billing:card-added'
export const BILLING_CREDIT_ADDED = 'billing:credit-added'
export const BILLING_TIER_CHANGED = 'billing:tier-changed'
export const UPSELL_SUBSCRIBE_TO = 'upsell:subscribe-to'

export const ACCOUNT_COMPLETE_REGISTRATION = 'account:complete-registration'
export const ACCOUNT_MERGE = 'account:merge'
export const AUTH_PASSWORD_SET = 'auth:password-set'
export const SHOW_SET_PASSWORD_MODAL = 'show-set-password-modal'
export const SHOW_PHONE_NUMBER_REQUIRED_MODAL = 'show-phone-number-required-modal'
export const PHONE_NUMBER_UPDATED = 'phone-number:updated'

export const IMPORT_LIST_REVIEW_PUBLISH = 'import-list:review-publish'
export const IMPORT_LIST_OVERRIDE_PRODUCT = 'import-list:override-product'
export const IMPORT_LIST_MODAL_CLOSED = 'import-list-modal-closed'
export const OVERRIDE_PRODUCT_SUCCESS = 'override-product-success'
export const UPDATE_IMPORT_LIST_COUNTER_BADGE = 'update_import_list_counter_badge'
export const PRODUCT_PUBLISHED_SUCCESS = 'product-published-success'
export const UPDATE_PRODUCT_LIST = 'update-product-list'
export const FIND_PRODUCTS_IMPORT_SUCCESS = 'find-products:import-success'
export const SHOW_PRODUCTION_CYCLE_INFO_MODAL = 'show-production-cycle-info-modal'
export const SHOW_AI_LIMIT_REACHED_MODAL = 'show-ai-limit-reached-modal'
export const SIMILAR_PRODUCT_SHOW = 'similar-product:show'
export const MY_PRODUCTS_DATA_REFRESH = 'my-products:data-refresh'
export const MY_PRODUCTS_IMPORT_SUCCESS = 'my-products:import-success'
export const MY_PRODUCTS_OVERRIDE_SUCCESS = 'my-products:override-success'
export const MY_PRODUCTS_OPEN_OVERRIDE_MODAL = 'my-products:open-override-modal'
export const MY_PRODUCTS_OPEN_LINK_PRODUCT_MODAL = 'my-products:open-link-product-modal'
export const MY_PRODUCTS_OPEN_LINK_VARIANT_MODAL = 'my-products:open-link-variant-modal'
export const MY_PRODUCTS_OPEN_IMAGE_PREVIEW = 'my-products:open-image-preview'

export const LINK_PRODUCT_MODAL_OPEN = 'link-product:open-modal'
export const LINK_VARIANT_MODAL_OPEN = 'link-variant:open-modal'
export const LINK_PRODUCT_ORDER_UPDATED = 'link-product:order-updated'
export const LINK_PRODUCT_REQUEST_QUOTE = 'link-product:request-quote'
export const LINK_PRODUCT_MODAL_CLOSE = 'link-product:close-modal'
export const ORDERS_OPEN_CREATE_ISSUE_MODAL = 'orders:open-create-issue-modal'
export const ORDERS_OPEN_ISSUE_DETAIL_MODAL = 'orders:open-issue-detail-modal'
export const ORDERS_ISSUE_CREATED = 'orders:issue-created'
export const ORDER_FIRST_FULFILLED = 'order:first-fulfilled'
export const ORDER_ISSUES_REFETCH = 'order-issues:refetch'
export const ORDER_ISSUES_OPEN_REVIEW_MODAL = 'order-issues:open-review-modal'
export const FULFILLMENT_STARTED = 'fulfillmentStarted'
export const FULFILLMENT_COMPLETED = 'fulfillmentCompleted'
export const CLEAR_FILTERS = 'clearFilters'

export const REQUEST_PRODUCT_LIMIT_REACHED = 'request-product:limit-reached'
export const REQUEST_PRODUCT_PLUS_USER_LIMIT_REACHED = 'request-product:plus-user-limit-reached'

export const SHOW_DISCONNECT_STORE_MODAL = 'show-disconnect-store-modal'
export const TIKTOK_WAREHOUSE_SHOW = 'tiktok-warehouse:show'

export const CLEAR_NOTIFICATIONS = 'clear-notifications'
export const SHELL_PAGE_OWNER = 'shell:page-owner'
export const SHELL_USER = 'shell:user'
export const SHELL_TOKEN = 'shell:token'
export const SHELL_ACTIVE_STORE = 'shell:active-store'
export const SHELL_THEME = 'shell:theme'
export const SHELL_PRICE_LIST = 'shell:price-list'
export const SHELL_LOGOUT = 'shell:logout'
export const LOCALE_CHANGED = 'locale:changed'
export const ISLAND_USER = 'island:user'
export const ISLAND_ACTIVE_STORE = 'island:active-store'
export const ISLAND_NOT_FOUND = 'island:not-found'
export const AI_CHAT_TOGGLE = 'ai-chat:toggle'
export const AI_CHAT_OPEN = 'ai-chat:open'
export const AI_CHAT_CLOSE = 'ai-chat:close'
export const AI_CHAT_STATE = 'ai-chat:state'
export const ONBOARDING_BANNER_DISMISS = 'onboarding-banner-dismiss'
export const SHOW_CLOUDFLARE_CHALLENGE = 'show-cloudflare-challenge'
export const CLOSE_CLOUDFLARE_CHALLENGE = 'close-cloudflare-challenge'

export const SUPPLIER_CONNECT_STORE_MODAL_OPEN = 'supplier-connect-store:open-modal'

export const V3_TO_V2_BUFFERED_EVENTS = [
  UPGRADE_PLAN_SHOW_PAYMENT_MODAL,
  BILLING_OPEN_ADD_CARD_MODAL,
  BILLING_OPEN_MANAGE_PLAN_MODAL,
  AUTH_PASSWORD_SET,
  MY_PRODUCTS_OPEN_OVERRIDE_MODAL,
  MY_PRODUCTS_OPEN_LINK_PRODUCT_MODAL,
  MY_PRODUCTS_OPEN_LINK_VARIANT_MODAL,
  MY_PRODUCTS_OPEN_IMAGE_PREVIEW,
  LINK_PRODUCT_ORDER_UPDATED,
  SHELL_PAGE_OWNER,
  SHELL_USER,
  SHELL_TOKEN,
  SHELL_ACTIVE_STORE,
  SHELL_THEME,
  SHELL_PRICE_LIST,
]

// Open-triggers for the global modals + AI sidebar, which are now
// defineAsyncComponent (FE-704). Their EventBusV3.on() only registers after the
// chunk loads, so an open emitted during that window would be dropped by mitt.
// Buffering these replays the missed open once the async listener registers.
export const ASYNC_MODAL_OPEN_EVENTS = [
  SHOW_UPGRADE_PLAN_MODAL,
  SHOW_UPGRADE_PLAN_MODAL_V2,
  SHOW_UBB_UPGRADE_PLAN_MODAL,
  SHOW_TRIAL_MODAL,
  SHOW_PAYMENT_INFORMATION_MODAL,
  UPSELL_SUBSCRIBE_TO,
  SHOW_SET_PASSWORD_MODAL,
  SHOW_PHONE_NUMBER_REQUIRED_MODAL,
  SHOW_PRODUCTION_CYCLE_INFO_MODAL,
  BILLING_OPEN_CC_MODAL,
  BILLING_OPEN_PAYPAL_MODAL,
  SIMILAR_PRODUCT_SHOW,
  TIKTOK_WAREHOUSE_SHOW,
  SHOW_DISCONNECT_STORE_MODAL,
  REQUEST_PRODUCT_LIMIT_REACHED,
  REQUEST_PRODUCT_PLUS_USER_LIMIT_REACHED,
  ORDERS_OPEN_CREATE_ISSUE_MODAL,
  ORDERS_OPEN_ISSUE_DETAIL_MODAL,
  LINK_PRODUCT_MODAL_OPEN,
  LINK_VARIANT_MODAL_OPEN,
  LINK_PRODUCT_REQUEST_QUOTE,
  ACCOUNT_MERGE,
  ACCOUNT_COMPLETE_REGISTRATION,
  ORDER_FIRST_FULFILLED,
  IMPORT_LIST_REVIEW_PUBLISH,
  IMPORT_LIST_OVERRIDE_PRODUCT,
  AI_CHAT_TOGGLE,
  AI_CHAT_OPEN,
]
